import { Route, Routes } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import FallbackSpin from '@/components/Shared/FallbackSpin';
import UserPlan from '../views/UserPlan';
import IsAdminMiddleware from '@/utils/IsAdminMiddleware';
import UserShares from '../views/UserShares';

const Profile = lazy(() => import('../views/Profile'));

export const UserRoutes = () => {
  return (
    <Suspense fallback={<FallbackSpin />}>
      <Routes>
        <Route path="profile" element={<Profile />} />
        <Route
          path="user-plan"
          element={
            <IsAdminMiddleware>
              <UserPlan />
            </IsAdminMiddleware>
          }
        />
        <Route path="my-shares" element={<UserShares />} />
      </Routes>
    </Suspense>
  );
};
